export default class BookingCancelFormManager {
    constructor() {
        this.eventDelegation();
    }

    eventDelegation() {
        $('body').on('change', '[data-action="select-reason"]', (event) =>
        {
            if ($(event.target).val() === '7') {
                $('[data-content="other"]').removeClass('hidden');
            } else {
                $('[data-content="other"]').addClass('hidden');
            }

            let cancellationReasonsDisplayCallRequest = ['9','10'];
            if (cancellationReasonsDisplayCallRequest.includes($(event.target).val())) {
                $('[data-action="callRequest"]').show();
            } else {
                $('[data-action="callRequest"]').hide();
            }

            if ($(event.target).val() === '11') {
                $('[data-action="includeFile"]').show();
            } else {
                $('[data-action="includeFile"]').hide();
            }

        });

        $('body').on('click', '#booking_cancellation_reason_button', (event) =>
        {
            let check = document.querySelector('#titular_verification');
            event.preventDefault();
            event.stopImmediatePropagation();

            let form = $('form[name="booking_cancellation_reason"]');
            let url = form.attr('action');
            let file = $("#booking_cancellation_reason_file").prop('files')[0];
            let formData = new FormData();
            formData.append('file', file);
            formData.append('booking_cancellation_reason[cancellationReason]', $('[name="booking_cancellation_reason[cancellationReason]"]').val());
            formData.append('booking_cancellation_reason[others]', $('[name="booking_cancellation_reason[others]"]').val());
            if ((check == null) || (check.checked)) {
                $('#booking_cancellation_reason_button').button('loading');
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: formData,
                    contentType: false,
                    processData: false,
                    dataType: "JSON"
                }).done(function (response) {
                    let message;
                if (response.status == 0) {
                    if (response.url != null) {
                        location.href = response.url;
                    } else {
                        message = '<div class="alert alert-success margin-top-10"><i class="ci ci-fire ci-s-12"></i> ' + response.message + '</div>';
                    }
                } else {
                    message = '<div class="alert alert-danger margin-top-10"><i class="ci ci-fire ci-s-12"></i> ' + response.message + '</div>';
                }
                $('#booking_cancellation_reason_button').button('reset');
                $('#cancel_booking_request_modal').find('.custom-modal-body').html(message);
                if (response.displayInformationAndReactivateBooking) {
                    $('[data-container="help-option-response"]').hide();
                    $('[data-action="reactivateBooking"]').show();
                    $('[data-action="messageInformation"]').html(response.messageCancellation);
                    $('[data-action="bookingId"]').val(response.booking.id);
                    $('[data-action="bookingDni"]').val(response.booking.dni);
                    $('[data-action="bookingEmail"]').val(response.booking.email);
                    $('[data-action="bookingToken"]').val(response.booking.token);
                }
                });
            } else {
                $('#titular_validation_error_message').prop('hidden',false);
            }
        });
    }
}